/* eslint-disable prefer-const */
import { DOMAIN_CDN, SPA } from '@base/constants'
import type { CSSProperties, FC } from 'react'
import { useMemo } from 'react'

export interface Props {
  /** 所属业务领域，一般来自 config/index.ts的name字段 */
  domain: string
  className?: string
  style?: CSSProperties
  src: string
  onClick?: (e: React.MouseEvent<HTMLImageElement, MouseEvent>) => void
  [k: string]: any
}

/** 通用icon组件 */
const Picture: FC<Props> = (props) => {
  let { domain, style, className, src, onClick, ...rest } = props
  return useMemo(() => {
    if (!src) {
      return null
    }
    if (src.startsWith('https://') || src.startsWith('http://')) {
      // 网络图片
    } else if (src.startsWith('data:image')) {
      // base64
    } else {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      src = `${DOMAIN_CDN}/${SPA === 'react' ? 'r' : 'v'}/${domain}/assets/images${src}`
    }
    return (
      <img
        src={src}
        onClick={(e) => {
          onClick?.(e)
        }}
        {...rest}
        style={style}
        className={className}
      />
    )
  }, [className, onClick, src, style])
}

export default Picture
